import { cellRenderStorageTimeCount } from '../../../utils/functions';

const columnDataIMZGP = [
  {
    dataField: 'remainingTimeProduction',
    caption: 'Осталось времени (производство)',
    cellRender: cellRenderStorageTimeCount,
    cssClass: 'td-button-cell-render',
    dataType: 'number'
  },
  {
    dataField: 'inco1',
    caption: 'INCO1',
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'hasShippingPlan',
    caption: 'Запланировано к отгрузке',
    dataType: 'boolean'
  }
];
export default columnDataIMZGP;
